import PropTypes from 'prop-types';
import { attr, fk, Model } from 'redux-orm';

class PatientIntegrationsAthena extends Model {
  static modelName = 'PatientIntegrationsAthena';

  static fields = {
    id: attr(),
    practiceId: attr(),
    athenaPatientId: attr(),
    department: attr(),
    departmentId: attr(),
    deletedAt: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    createdBy: fk('Client', 'patientIntegrationsAthenaCreator'),
    updatedBy: fk('Client', 'patientIntegrationsAthenaUpdater'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'patientIntegrationsAthena',
    }),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      practiceId: PropTypes.string,
      athenaPatientId: PropTypes.string,
      department: PropTypes.string,
      departmentId: PropTypes.string,
      deletedAt: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      updatedBy: PropTypes.number,
      createdBy: PropTypes.number,
      patientId: PropTypes.number,
    }),
    patientId: PropTypes.number,
  };
}

export default PatientIntegrationsAthena;
